export const getStatusColor = (fulfillmentPercentage: number) => {
  if (fulfillmentPercentage === 100) return 'success.main';
  if (fulfillmentPercentage < 0) return 'error.light';
  return 'warning.main';
};

export const calculateFulfillmentPercentage = (capacity: any, actual: any) => {
  if (capacity === actual) return 100;

  if (actual > capacity) {
    return -Math.round((actual / capacity) * 100);
  }

  return Math.round((1 - Math.abs(actual - capacity) / capacity) * 100);
};
